var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIconDrawer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.79211L8.12512 0.666992L15.2502 7.79211",
    stroke: "black",
    strokeWidth: 0.79168,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5835 6.20801V12.5414C2.5835 12.7514 2.6669 12.9528 2.81537 13.1013C2.96384 13.2497 3.16521 13.3331 3.37518 13.3331H5.75022C5.96018 13.3331 6.16155 13.2497 6.31002 13.1013C6.45849 12.9528 6.5419 12.7514 6.5419 12.5414V9.37473C6.5419 9.16476 6.62531 8.9634 6.77378 8.81493C6.92224 8.66646 7.12361 8.58305 7.33358 8.58305H8.91694C9.1269 8.58305 9.32827 8.66646 9.47674 8.81493C9.62521 8.9634 9.70862 9.16476 9.70862 9.37473V12.5414C9.70862 12.7514 9.79203 12.9528 9.9405 13.1013C10.089 13.2497 10.2903 13.3331 10.5003 13.3331H12.8753C13.0853 13.3331 13.2867 13.2497 13.4351 13.1013C13.5836 12.9528 13.667 12.7514 13.667 12.5414V6.20801",
    stroke: "black",
    strokeWidth: 0.79168,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIconDrawer);
export default __webpack_public_path__ + "static/media/HomeIconDrawer.0159701a4427331181ca0c41d3ea210f.svg";
export { ForwardRef as ReactComponent };